import pcAdver from "mptcfe-pc-adver"
import fullScreenSleep from "./fullScreenSleep"
import utils from "@/components/adver/utils"

/**
 * @description 使用PC广告组件库，依赖于window上的MptcfeUtils
 * @param {*} data
 * @param {*} el
 * @param {*} spmCode
 */
const BaiduAsspAd = function (opt) {
    var data = opt && opt.data
    var el = opt && opt.el
    var spmCode = opt && opt.spmCode
    var resourceId = opt && opt.resourceId
    // TODO：写法粗糙，之后会移入广告组件，待重构
    if (spmCode?.includes('ad-fullScreenSleep')) {
        var contentId = Math.random().toString(36).slice(2, 8)
        var container = document.createElement('a');
        container.setAttribute('href', 'javascript:void(0);')
        container.setAttribute('id', contentId)
        utils.setDomStyle(container, {
            width: "100%",
            height: "100%",
            display: "inline-block",
        })
        el.append(container)
        if (data.adData.noactionTime > 0) {
            newNoactionLoadCallBack(function () {
                fullScreenSleep()
                new pcAdver.AdGenerator({
                    data: data,
                    location: spmCode,
                    wrapStyle: "width: 100%; height:100%;",
                    resourceId: resourceId,
                    success: function (adDom) {
                        document.getElementById(contentId).appendChild(adDom[0])
                    }
                })
            }, data.adData.noactionTime || 3 * 1000)
        } else {
            new pcAdver.AdGenerator({
                data: data,
                location: spmCode,
                resourceId: resourceId,
                success: function (adDom) {
                    document.getElementById(contentId).appendChild(adDom[0])
                }
            })
        }
    } else {
        new pcAdver.AdGenerator({
            data: data,
            location: spmCode,
            resourceId: resourceId,
            success: function (adDom) {
                el?.appendChild(adDom[0])
                typeof opt.success === 'function' && opt.success()
            }
        })
    }

}

/**
* @description 延迟加载百度广告 FIXME: 后续可能要接入广告组件
* @param {*} callBack
* @param {*} time
*/
var newNoactionLoadCallBack = function (callBack, time) {
    console.log('全屏防抖entry')
    //生成防抖函数
    var loadTime = 1
    var debounceFn = _.debounce(function () {
        console.log('全屏广告调用回调函数')
        callBack()
        loadTime--
    }, time)
    //提前调用一次
    debounceFn()
    //有滑动时重置时间
    window.addEventListener('scroll', function () {
        if (loadTime > 0) debounceFn()
    })
}

export default BaiduAsspAd